import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import {connect} from "react-redux";
import ContentPage from "../../components/ContentPage/ContentPage";
import {REQUEST_CUSTOMER_TESTIMONIALS_DATA} from "../../actions/customerTestimonialsActions";

const mapStateToProps = state => {
  return {
    customerTestimonials: state.customerTestimonialsData
  };
};

const mapDispatchToProps = dispatch => ({
  getCustomerTestimonialsData: () => dispatch({type: REQUEST_CUSTOMER_TESTIMONIALS_DATA})
});

class CustomerTestimonialItem extends Component {
  
  componentDidMount() {
    if (!Object.keys(this.props.customerTestimonials).length) {
      this.props.getCustomerTestimonialsData();
    }
  };
  
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        {
          Object.keys(this.props.customerTestimonials).length ? (
            <ContentPage
              content={this.props.customerTestimonials}
              arrayName="customerTestimonials"
              redirectPath="/about/customer-testimonials"
            />
          ) : <Skeleton type="IFRAME"/>
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(CustomerTestimonialItem));



// WEBPACK FOOTER //
// ./src/pages/About/CustomerTestimonialItem.js